import CardCommon from '@op/components/CardCommon';
import useLanguage from '@op/hooks/useLanguage';
import React, { useMemo, useState } from 'react';
import { Col, Row, Segment } from 'tea-component';
import {
  gameStoreOneOptions,
  GameStoreOneOptionsType,
  gameStoreTwoOptions,
  GameStoreTwoOptionsType,
} from '../../constants';
import ReviewRating from '../ReviewRating';
import './index.scss';
import RatingChart from '../RatingChart';
import useGetGameStoreStatsInfo from '@op/widgets/GameStorePlate/hooks/useGetGameStoreStatsInfo';
import { getRationPercentValue } from '@op/utils';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import { useHistory } from 'umi';

export default function MobileStore({
  filter,
  wholeGameInfo,
  gameInfo,
  games,
  gameData,
  showRank,
}: {
  filter: any;
  wholeGameInfo: any;
  gameInfo?: any;
  games: Array<any>;
  gameData: any;
  showRank: boolean;
}) {
  const { formatMessage, formatOptionsMessage } = useLanguage();
  const [store, setStore] = useState<GameStoreOneOptionsType>('google play');
  const [type, setType] = useState<GameStoreTwoOptionsType>('lifetime');

  const { ratingInfo, loading, oldRatingInfo } = useGetGameStoreStatsInfo({
    gameInfo,
    filter,
    type: store,
    needLink: true,
  });

  const data = useMemo(() => {
    const newRating = ratingInfo?.[type] || {};
    const oldRating = oldRatingInfo?.[type] || {};

    return {
      ...newRating,
      oldValue: oldRating.score,
      newValue: newRating.score,
      rationPercent: getRationPercentValue(newRating.score, oldRating.score, 6),
      oldTime: oldRating.time ? oldRating.time : [],
      newTime: newRating.time ? newRating.time : [],
    };
  }, [type, ratingInfo, oldRatingInfo]);

  const history = useHistory();

  return (
    <CardCommon
      contentCard
      title={<span style={{ fontSize: 20 }}>
        {formatMessage({ id: 'Game Store' })}
      </span>}
      id="Game Store"
      hasTitleArrow
      handleTitleOnClick={() => {
        history.push('/opinion/GameStore');
      }}
      className="dbo-key-metrics-mobile-store card-slot"
      logBtnId="KMGS"
    >
      <CardCommon className="card-common-dbo-key-metrics">
        <Segment
          value={store}
          onChange={(value: GameStoreOneOptionsType) => {
            buriedBtnPoint('KMGS_StoreMetricsTAB', value);
            setStore(value);
          }}
          options={gameStoreOneOptions(store)}
        />
        <Segment
          value={type}
          onChange={(value: GameStoreTwoOptionsType) => {
            buriedBtnPoint('KMGS_RatingMetricsTAB', value);
            setType(value);
          }}
          options={formatOptionsMessage(gameStoreTwoOptions)}
        />

        <Row className="dbo-key-metrics-mobile-store-content">
          <Col span={12}>
            <CardCommon contentCard loading={loading} loadingHeight={240}>
              <ReviewRating
                ratingData={data}
                platform={store}
                type={type}
                games={games}
                gameData={gameData}
                filter={filter}
                showRank={showRank}
                detailPage={type === 'selected'}
              />
            </CardCommon>
          </Col>
          <Col span={12}>
            <RatingChart filter={filter} platform={store} type={type} detailPage={type === 'selected'} isDetail={false} />
          </Col>
        </Row>
      </CardCommon>
    </CardCommon>
  );
}
